var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForkKnife(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H10V15C10 15.5523 10.4477 16 11 16H12V23.5C12 23.7761 12.2239 24 12.5 24C12.7761 24 13 23.7761 13 23.5V16H14C14.5523 16 15 15.5523 15 15V10H14V15H13V10H12V15H11V10Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 23.5C22 23.7761 21.7761 24 21.5 24C21.2239 24 21 23.7761 21 23.5V19H18L18.0005 12.75C18.0005 12.2523 18.1971 11.5495 18.8255 10.9748C19.4563 10.3978 20.4662 10 22.0005 10L22 23.5ZM19.5004 11.7127C19.785 11.4525 20.2498 11.1966 21 11.0743V18H19L19.0005 12.75C19.0005 12.4978 19.1038 12.0755 19.5004 11.7127Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkKnife);
export default __webpack_public_path__ + "static/media/fork_knife.f58c5dbb3c1b7d5d98a08ced78883f13.svg";
export { ForwardRef as ReactComponent };